import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getErrorMessage } from "./api/client.ts";

// Let a query or mutation opt out of the global error toast when the caller
// already handles the failure: an expected configuration state (e.g. a tenant
// with no CRM connection mapped) or an error shown inline in a form or dialog.
// `live`: data the realtime connection keeps fresh, polled instead while that
// connection is down (`realtime/useSseInvalidations.ts`).
declare module "@tanstack/react-query" {
  interface Register {
    queryMeta: { suppressErrorToast?: boolean; live?: boolean };
    mutationMeta: { suppressErrorToast?: boolean };
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.suppressErrorToast) return;
      toast.error(getErrorMessage(error));
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.suppressErrorToast) return;
      toast.error(getErrorMessage(error));
    },
  }),
});
